import { api } from '@/lib/api-client'
import { logger } from '@/lib/logger'
import { LoginRequest, TokenResponse } from '@/types/auth-types'

/**
 * Fetch authentication token from the API
 * @param payload - Login credentials
 * @returns Token response with access token and metadata
 */
const fetchTokenTyped = async (payload: LoginRequest): Promise<TokenResponse> => {
  try {
    logger.info('Attempting login', { username: payload.username })

    const tokenString = await api
      .post(`auth/token`, {
        json: {
          username: payload.username,
          password: payload.password,
          rememberMe: payload.rememberMe || false,
          returnUrl: payload.returnUrl,
        },
      })
      .json<string>()

    if (!tokenString) {
      throw new Error('Invalid response: missing access token')
    }

    logger.info('Login successful', { username: payload.username })

    return {
      access_token: tokenString,
      token_type: 'Bearer',
      expires_in: 3600,
    }
  } catch (error) {
    logger.error('Login error', error)

    // Handle ky-specific errors
    if (error instanceof Error && 'response' in error) {
      const kyError = error as any
      if (kyError.response?.status === 401) {
        throw new Error('Invalid username or password')
      } else if (kyError.response?.status === 429) {
        throw new Error('Too many login attempts. Please try again later.')
      } else {
        throw new Error(`Login failed: ${kyError.message}`)
      }
    }

    throw error
  }
}

export default fetchTokenTyped
